module.exports = __webpack_public_path__ + "img/p8.7580bb42.png";